module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pl10 mt20",
    staticStyle: {
      "word-break": "break-all"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.control.loginType == 1),
      expression: "control.loginType == 1"
    }],
    staticClass: "pr10 mb10",
    attrs: {
      "align": "right"
    }
  }, [(_vm.records.length > 0) ? _c('el-table', {
    attrs: {
      "data": _vm.records,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "供应商编号",
      "min-width": "200",
      "align": "center",
      "prop": "supplierCode"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "supplierName",
      "label": "供应商名称",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "当前状态",
      "min-width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.supplierStatusName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "修改原因",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "auditRemark",
      "label": "审核备注",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.editFinanceData(scope.row.id)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status == 1 || scope.row.status == 4 ? '编辑' : '查看'))]), _vm._v(" "), (scope.row.status == 1 || scope.row.status == 4) ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.deleteRecord(scope.row.id, scope.row.status)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status == 1 ? '删除' : '取消'))]) : _vm._e()]
      }
    }])
  })], 1) : _vm._e(), _vm._v(" "), (_vm.records.length == 0) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editFinanceData(0)
      }
    }
  }, [_vm._v("修改财务信息")]) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "dib"
  }, [_vm._v("税务信息")]), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "mt20"
  }, [_c('el-form', {
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.financeData,
      "label-width": "207px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "纳税人识别号："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.financeData.taxpayerRegistrationCode))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "mt20",
    attrs: {
      "label": "纳税人类型："
    }
  }, [(_vm.financeData.taxpayerType == 1) ? _c('span', [_vm._v("一般纳税人")]) : _vm._e(), _vm._v(" "), (_vm.financeData.taxpayerType == 2) ? _c('span', [_vm._v("小规模纳税人")]) : _vm._e()]), _vm._v(" "), (_vm.financeData.taxpayerType == 1) ? _c('el-form-item', {
    attrs: {
      "label": "一般纳税人资格认定表：",
      "prop": "generalTaxpayerFile"
    }
  }, [_c('div', [(_vm.financeData.generalTaxpayerFile) ? _vm._l((_vm.financeData.generalTaxpayerFile.split(',')), function(gtFile) {
    return _c('img', {
      staticClass: "pic_skan",
      attrs: {
        "src": gtFile
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    })
  }) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dib"
  }, [_vm._v("货款支付账户")]), _c('span', {
    staticClass: "second_line"
  }), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "80%",
      "margin": "0 auto",
      "margin-bottom": "22px",
      "margin-top": "22px"
    },
    attrs: {
      "data": _vm.financeData.accounts,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "银行开户名",
      "min-width": "200",
      "align": "center",
      "prop": "accountName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "accountNumber",
      "label": "银行帐号",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bankName",
      "label": "银行名称",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), (_vm.financeData.registeredCountry != 1) ? _c('el-table-column', {
    attrs: {
      "prop": "swiftCode",
      "label": "SwiftCode",
      "min-width": "200",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.financeData.registeredCountry == 1) ? _c('el-table-column', {
    attrs: {
      "prop": "province",
      "label": "省",
      "min-width": "200",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.financeData.registeredCountry == 1) ? _c('el-table-column', {
    attrs: {
      "prop": "city",
      "label": "市",
      "min-width": "200",
      "align": "center"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "size": "small"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-111238ff"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/supplierInfo/financeInfo.vue
// module id = 487
// module chunks = 0